import React, { useMemo } from 'react';
import './style.css';

export const SkeletonTable = () => {
  const columns =useMemo(()=> Array(5).fill('Column') ,[]);
  const rows =useMemo(()=> Array(6).fill('Column') ,[]) ;
  
  return (
    <div className="table-container">
      <table className="scrollable-table">
        {/* Table Header */}
        <thead className="table-header">
          <tr>
            {columns.map((_, index) => (
              <th key={`col-${index}`}>
                <div className="skeleton-header"></div>
              </th>
            ))}
          </tr>
        </thead>
        
        {/* Table Body */}
        <tbody className="table-body">
          {rows.map((_, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              {columns.map((_, colIndex) => (
                <td key={`cell-${rowIndex}-${colIndex}`}>
                  <div className="skeleton-cell"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};